import axios from 'axios'
import { SELL_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getAll(page, filter) {

    const params = {
        page,
        filter
    }

    return axios.get(SELL_URL, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getItemListByPrefix(prefix) {
    const URL = SELL_URL + '/prefix/' + prefix;
    return axios.get(URL,
        {
            headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
        })
}

export function get(id) {
    const url = `${SELL_URL}/${id}`

    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getIGV() {
    const url = `${SELL_URL}/igv`

    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function addSell(params, sell) {
    const url = `${SELL_URL}`
    return axios.post(url, sell, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}


// WEBPACK FOOTER //
// ./src/service/sell.js